// services/doctorService.js
import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

export const doctorService = {
  // Listar todos los doctores
  getAllDoctors: async (medicalCenterId = null) => {
    const url = new URL(`${BASE_URL}insurance/doctors/`);
    if (medicalCenterId) url.searchParams.set('medical_center', medicalCenterId);
    const res = await fetch(url.toString(), {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Error al cargar doctores');

    return data.results || data;
  },

  // 👇 AGREGAR ESTE MÉTODO NUEVO
  // Obtener doctor por ID
  getDoctorById: async (id) => {
    const res = await fetch(`${BASE_URL}insurance/doctors/${id}/`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });
    
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Error al cargar doctor');
    return data;
  },

  // Obtener perfil del doctor actual
  getMyProfile: async () => {
  const res = await fetch(`${BASE_URL}insurance/doctors/me/`, {
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
    },
  });

      // Si es 403 o 404, devolvemos null (usuario no es doctor)
      if (res.status === 403 || res.status === 404) {
        return null; // 👈 No lanzar error
      }

      const data = await res.json();
      if (!res.ok) {
        console.warn('Error al cargar perfil del doctor:', data.error || 'Error desconocido');
        return null; // O puedes lanzar un error si lo necesitas
      }

      return data;
    },

  // Crear nuevo doctor
// Modifica temporalmente tu doctorService.js para ver la respuesta completa:
createDoctor: async (doctorData) => {
  console.log('📤 Enviando a /insurance/doctors/:', doctorData);
  
  try {
    const res = await fetch(`${BASE_URL}insurance/doctors/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(doctorData),
    });
    
    // Ver el texto completo de la respuesta
    const textResponse = await res.text();
    console.log('📥 Respuesta completa:', textResponse);
    
    // Intentar parsear como JSON
    let data;
    try {
      data = JSON.parse(textResponse);
    } catch (e) {
      console.error('❌ La respuesta no es JSON, es HTML de error:', textResponse.substring(0, 500));
      throw new Error('Error interno del servidor (respuesta HTML)');
    }
    
    if (!res.ok) {
      let errorMessage = 'Error al crear doctor';
      if (data.error) errorMessage = data.error;
      else if (data.email) errorMessage = `Email: ${data.email[0]}`;
      else if (data.password) errorMessage = `Contraseña: ${data.password[0]}`;
      throw new Error(errorMessage);
    }
    
    return data;
  } catch (error) {
    console.error('❌ Error en createDoctor:', error);
    throw error;
  }
},

  // Actualizar doctor
  updateDoctor: async (id, doctorData) => {
    const res = await fetch(`${BASE_URL}insurance/doctors/${id}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(doctorData),
    });
    
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Error al actualizar doctor');
    return data;
  },

  // Eliminar doctor
  deleteDoctor: async (id) => {
    const res = await fetch(`${BASE_URL}insurance/doctors/${id}/`, {
      method: 'DELETE',
      headers: {
        ...getAuthHeader(),
      },
    });
    
    if (!res.ok) {
      const data = await res.json();
      throw new Error(data.error || 'Error al eliminar doctor');
    }
    return { success: true };
  },

  // Asignar centros médicos a doctor
  assignMedicalCenters: async (id, medicalCenterIds) => {
    const res = await fetch(`${BASE_URL}insurance/doctors/${id}/assign_medical_centers/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify({
        medical_center_ids: medicalCenterIds
      }),
    });
    
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Error al asignar centros médicos');
    return data;
  },

  // Verificar doctor
  verifyDoctor: async (id) => {
    const res = await fetch(`${BASE_URL}insurance/doctors/${id}/verify/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });
    
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Error al verificar doctor');
    return data;
  },

  // Obtener centros médicos del doctor
  getDoctorMedicalCenters: async (id) => {
    const res = await fetch(`${BASE_URL}insurance/doctors/${id}/medical-centers/`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });
    
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Error al cargar centros médicos');
    return data;
  },

  // Subir firma y sello del doctor
  uploadSignature: async (id, file) => {
    const formData = new FormData();
    formData.append('firma_sello', file);
    
    const res = await fetch(`${BASE_URL}insurance/doctors/${id}/`, {
      method: 'PATCH',
      headers: {
        ...getAuthHeader(),
      },
      body: formData,
    });
    
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Error al subir firma y sello');
    return data;
  },

  // Legacy: crear doctor usando endpoint form-data (/insurance/doctores/create/)
  createDoctorLegacy: async (formData) => {
    // Log FormData entries for debugging (files will appear as File objects)
    try {
      console.log('createDoctorLegacy - sending FormData:');
      for (const pair of formData.entries()) {
        console.log('  ', pair[0], pair[1]);
      }
    } catch (e) {
      console.warn('Could not iterate FormData for logging', e);
    }

    const res = await fetch(`${BASE_URL}insurance/doctores/create/`, {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
      },
      body: formData,
    });

    const text = await res.text();
    try {
      const data = JSON.parse(text);
      if (!res.ok) throw new Error(data.error || 'Error al crear doctor');
      return data;
    } catch (e) {
      console.error('createDoctorLegacy response not JSON', text.substring(0, 500));
      throw new Error('Error en el servidor al crear doctor');
    }
  },

  // Legacy: editar doctor usando endpoint form-data (/insurance/doctores/{id}/edit/)
  editDoctorLegacy: async (id, formData) => {
    // Log FormData entries for debugging
    try {
      console.log(`editDoctorLegacy(${id}) - sending FormData:`);
      for (const pair of formData.entries()) {
        console.log('  ', pair[0], pair[1]);
      }
    } catch (e) {
      console.warn('Could not iterate FormData for logging', e);
    }

    const res = await fetch(`${BASE_URL}insurance/doctores/${id}/edit/`, {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
      },
      body: formData,
    });

    const text = await res.text();
    try {
      const data = JSON.parse(text);
      if (!res.ok) throw new Error(data.error || 'Error al editar doctor');
      return data;
    } catch (e) {
      console.error('editDoctorLegacy response not JSON', text.substring(0, 500));
      throw new Error('Error en el servidor al editar doctor');
    }
  }
};

// Función legacy para compatibilidad
export async function getUserMedicalCenters() {
  try {
    const response = await fetch(`${BASE_URL}insurance/doctores/user-medical-centers/`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });
    
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Error al cargar centros médicos');
    return data;
  } catch (error) {
    console.error('Error en getUserMedicalCenters:', error);
    throw error;
  }
}